<template>
    <li class="nav-item dropdown" v-if="hasChildren">
        <a class="nav-link dropdown-toggle" data-toggle="dropdown" v-link="{ path: item.link }" role="button" v-on:click="hideMenu" v-bind:class="{ 'active': active }">{{ item.name }}</a>
        <div class="nav-link-dropdown" v-bind:class="{ 'active': open }">
            <menu-item v-for="item of item.children" :item="item" :is-children="true" ></menu-item>
        </div>
    </li>
    <li class="nav-item" v-else>
        <a class="nav-link" v-bind:class="{ 'active': active }" v-link="{ path: item.link }" v-on:click="hideMenu">{{ item.name }}</a>
    </li>
</template>

<script>
  import $ from 'jquery'

  export default{
    name: 'menu-item',
    props: [
      'item',
      {
        'name': 'isChildren',
        'type': Boolean,
        'default': false
      }
    ],
    data: () => ({ selected: false }),
    computed: {
      hasChildren () { return this.item.children && !!this.item.children.length },
      active () {
        let link = (this.isChildren) ? '/' + this.item.link : this.item.link
        return (this.$route.path === link || this.open)
      },
      open: function () {
        let regexp = new RegExp('^' + this.item.link, 'i')
        return Array.isArray(this.item.children) &&
          this.item.children.length > 0 &&
          (this.$route.path.search(regexp) !== -1 || this.active)
      }
    },
    methods: {
      hideMenu: function () {
        $('body').removeClass('with--sidebar')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MenuItem.vue?d6a51ade